import { NavigationButton } from "@components/common/NavigationLink";
import { useUserContext } from "@contexts/UserContext/index.context";
import { Groups, PersonAddAlt } from "@mui/icons-material";
import { UserRank } from "@types_def/models/user.type";
import { RoutePaths } from "@utils/constants/routes";
import { useTranslation } from "react-i18next";

import LinksSubHeader from "..";

function ClientOrganizationSubHeader() {
  const { userState } = useUserContext();
  const { t } = useTranslation();
  return (
    <LinksSubHeader>
      <NavigationButton
        to={RoutePaths.clientOrganizationAddMember}
        includes={RoutePaths.organizationAddMember}
      >
        <PersonAddAlt />
        <span style={{ fontSize: "0.75rem" }}>
          {t("layouts.sub-headers.organization.add-member")}
        </span>
      </NavigationButton>
      {UserRank.ORGANIZATION_OWNER === userState?.["custom:rank"] ? (
        <NavigationButton
          to={RoutePaths.clientOrganizationListManager}
          includes={RoutePaths.organizationListManagers}
        >
          <Groups />
          <span style={{ fontSize: "0.75rem" }}>
            {t("layouts.sub-headers.organization.managers")}
          </span>
        </NavigationButton>
      ) : null}
      <NavigationButton
        to={RoutePaths.clientOrganizationListMember}
        includes={RoutePaths.organizationListMembers}
      >
        <Groups />
        <span style={{ fontSize: "0.75rem" }}>{t("layouts.sub-headers.organization.members")}</span>
      </NavigationButton>
    </LinksSubHeader>
  );
}

export default ClientOrganizationSubHeader;
